import React, { useRef, useState } from 'react';
import {
  AiChatButton,
  ButtonChat,
  LeftCol,
  LogoPriceContainer,
  LogoResultContainer,
  PriceContainer,
  PriceResult,
  QuoteInformationResultContainer,
  QuoteInformationResultItem,
  RiskCardSelectedStyles,
} from '../ResultPageComponents/v2/SelectedQuoteCard.styles';
import { BACKEND_BASE_URL } from '../../../../config';
import SparklesIcon from '../../../../assets/images/icons/SparklesIcon';
import { Chat } from '../../chats/MiniChat/MiniChat';

function RiskCardPrimaResult({ quote, processingQuote }) {
  // const includesCoverage = (key) => modalCoverages !== null && modalCoverages.includes(key);
  const [openChat, setOpenChat] = useState(false);
  const chatRef = useRef();
  const extraText = `Limit: ${quote.limits_name}`;

  const cheapestGuaranteePrice = [
    ...quote.quotation_data_prima_guarantee_prices,
  ].sort(
    (a, b) => parseFloat(a.discounted) - parseFloat(b.discounted),
  )[0];

  return (
    <RiskCardSelectedStyles className="selected">
      <div className="row-container">
        <LeftCol>
          <LogoPriceContainer>
            <LogoResultContainer>
              <img
                src={BACKEND_BASE_URL + processingQuote.company.logo}
                alt={processingQuote.company.name}
              />
            </LogoResultContainer>
            <PriceContainer>
              <PriceResult>
                <h5>Prezzo annuo:</h5>
                <h2>
                  &euro;
                  {' '}
                  {parseFloat(cheapestGuaranteePrice.discounted).toFixed(2)}
                </h2>
              </PriceResult>
              {processingQuote.payment_frequency === 2 && (
                <PriceResult>
                  <h5>Prezzo Semestrale:</h5>
                  <h6>Primo Pagamento</h6>
                  <h2>
                    &euro;
                    {(
                      Number(cheapestGuaranteePrice.discounted / processingQuote.payment_frequency)
                    ).toLocaleString('it-IT', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </h2>
                </PriceResult>
              )}
            </PriceContainer>
          </LogoPriceContainer>
          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>{processingQuote.company.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Prodotto:</h6>
              <p>{quote.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Limit:</h6>
              <p>{quote.limits_name}</p>
            </QuoteInformationResultItem>
          </QuoteInformationResultContainer>
          <ButtonChat>
            <AiChatButton onClick={() => setOpenChat(true)}>
              <SparklesIcon width={24} height={24} />
              <span>Chiedi all'AI</span>
            </AiChatButton>
            <Chat
              ref={chatRef}
              openChat={openChat}
              setOpenChat={setOpenChat}
              company_id={processingQuote.company_id}
              product_id={processingQuote.product_id}
              quote_type={quote.quote_type}
              company_name={processingQuote.company.name}
              extraText={extraText}
              sub_product={null}
            />
          </ButtonChat>
        </LeftCol>
      </div>
    </RiskCardSelectedStyles>
  );
}

export default RiskCardPrimaResult;
